import { gql } from '@apollo/client';

export const GET_LATEST_TERMINATION = gql`
  query GET_LATEST_TERMINATION($projectId: ID!) {
    latestTermination(projectId: $projectId) {
      isTerminated
      termination {
        id
        date
        reason
      }
    }
  }
`;

export const SUBMIT_TERMINATION = gql`
  mutation SubmitTerminationMutation($input: SubmitTerminationInput!) {
    submitTermination: submitTermination(input: $input) {
      project {
        title
      }
    }
  }
`;

export const SUBMIT_TERMINATION_WITH_CUSTOM_DATE = gql`
  mutation SubmitTerminationWithCustomDateMutation(
    $input: SubmitTerminationWithCustomDateInput!
  ) {
    submitTermination: submitTerminationWithCustomDate(input: $input) {
      project {
        title
      }
    }
  }
`;
